import cssRaw from "./design-tokens.css?raw";

function parseVar(name: string): string {
    const regex = new RegExp(`${name}:\\s*(.+?)\\s*;`);
    const match = cssRaw.match(regex);
    if (!match) throw new Error(`Token ${name} not found in design-tokens.css`);
    return match[1];
}

export const designTokens = {
    color: {
        danger: parseVar("--color-danger"),
        warning: parseVar("--color-warning"),
        success: parseVar("--color-success"),
        gray: parseVar("--color-gray"),
        lightGray: parseVar("--color-lightGray"),
        darkGray: parseVar("--color-darkGray"),
        lightBlack: parseVar("--color-lightBlack"),
        black: parseVar("--color-black"),
        darkBlack: parseVar("--color-darkBlack"),
        brown: parseVar("--color-brown"),
        white: parseVar("--color-white"),
        lightGrayBgCard: parseVar("--color-lightGrayBgCard"),
        blue: parseVar("--color-blue"),
        lightBlue: parseVar("--color-lightBlue"),
        fluorBlue: parseVar("--color-fluorBlue"),
        yellow: parseVar("--color-yellow"),
        lineRed: parseVar("--color-lineRed"),
        lineBlue: parseVar("--color-lineBlue"),
        lineGreen: parseVar("--color-lineGreen"),
        linePurple: parseVar("--color-linePurple"),
        lineOrange: parseVar("--color-lineOrange"),
        lineCyan: parseVar("--color-lineCyan"),
        lineYellow: parseVar("--color-lineYellow"),
        lineBrown: parseVar("--color-lineBrown"),
        linePink: parseVar("--color-linePink"),
        lineTeal: parseVar("--color-lineTeal"),
        lineOlive: parseVar("--color-lineOlive"),
        lineIndigo: parseVar("--color-lineIndigo"),
        lineCoral: parseVar("--color-lineCoral"),
        lineTurquoise: parseVar("--color-lineTurquoise"),
        lineLime: parseVar("--color-lineLime"),
        lineMagenta: parseVar("--color-lineMagenta"),
        lineSlate: parseVar("--color-lineSlate"),
        lineAqua: parseVar("--color-lineAqua"),
        lineGold: parseVar("--color-lineGold"),
        lineCrimson: parseVar("--color-lineCrimson"),
    },
    font: {
        sans: parseVar("--font-sans"),
    },
} as const;
